/* eslint-disable react/no-danger */
import { useState, useEffect, Fragment } from 'react';

import Head from 'next/head';
import { useRouter } from 'next/router';
import { Link as Slink, animateScroll as scroll } from 'react-scroll';
import { Container, Row, Col } from 'reactstrap';

import Collapse from '../../components/includes/collapse';
import Layout from '../../components/layout/layout';
import { buttonClickEvent } from '../../helpers/segment';
import useI18n from '../../hooks/use-i18n';
import { languages, contentLanguageMap, countryMap } from '../../language.config';
import { faqDisabledMarkets, freshMarkets,
  sonicGoMarkets, waterflosserMarkets, whiteningMarkets, faqEnabledMarkets,
  obt3EnabledMarkets } from '../../links.config';
import getTranslationKeys, { PAGEID } from '../../utils/i18nRosseta';
import { useUtmParam as useUtmData } from '../../utils/utils';

import '../../styles/faqs.scss';

const Faqs = () => {
  const i18n = useI18n();
  const faqBuffData = Object.values(i18n.t('faqs'));
  const faqBuffKeys = Object.keys(i18n.t('faqs'));
  const codes = i18n.activeLocale.split('-');
  const country = codes.length === 2 ? codes[0] : 'sg';

  faqBuffData.forEach((element, index) => {
    faqBuffData[index].key = faqBuffKeys[index];
  });
  const faqData = [];
  if (country === 'tw') {
    [faqData[0],, faqData[5], faqData[4],
      faqData[1],, faqData[6], faqData[7],, faqData[2]] = faqBuffData;
  } else if (country === 'th') [faqData[0],, faqData[5], faqData[4],, faqData[1], faqData[6], faqData[7]] = faqBuffData;
  else {
    [faqData[0],, faqData[7],
      faqData[6], faqData[2], faqData[1], faqData[8], faqData[9], faqData[5], faqData[4], faqData[3]] = faqBuffData;
  }

  // if (!brightMarkets.includes(country) && country !== 'tw') faqData.splice(3, 1);
  if (!freshMarkets.includes(country) && country !== 'tw') faqData.splice(1, 1);

  if (!waterflosserMarkets.includes(country) && country !== 'tw') faqData.splice(2, 1);
  if (!sonicGoMarkets.includes(country)) faqData.splice(3, 1);
  if (!whiteningMarkets.includes(country) && country !== 'vn' && country !== 'jp') faqData.splice(3, 1);
  if (!whiteningMarkets.includes(country) && country === 'vn') faqData.splice(2, 1);

  if (country === 'jp') {
    faqData.splice(1, 1);
    faqData.splice(1, 1);
  }

  const lang = codes[1] || 'en';
  const router = useRouter();
  const query = router && router.query;
  const [isSTT, toggleIsSTT] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [utmParams, setUtmParams] = useState('');
  const pageMetaData = i18n.t('metadata').faqPage;

  useEffect(() => {
    setIsMobile(window.innerWidth < 992);
    window.addEventListener('scroll', scrollEventListner);
    return () => {
      window.removeEventListener('scroll', scrollEventListner);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setUtmParams(useUtmData('FAQs'));
    }, 50);
  }, [query]);

  useEffect(() => {
    if (faqDisabledMarkets.includes(country)) window.location.replace(`/${i18n.activeLocale}`);
  }, [country]);

  const scrollEventListner = () => {
    toggleIsSTT(window.pageYOffset > 100);
  };

  return (
    <Layout
      page="faqs"
      title={pageMetaData.title}
      insiderPage="FAQs"
      description={pageMetaData.description}
      keywords={pageMetaData.keywords}
      analyticData={{ name: 'FAQ', properties: { } }}
      pageUrl="faqs"
      pageEnabledMarkets={faqEnabledMarkets}
    >
      <Head />
      <section className="faq-head">
        <Container>
          <div className="faq-wrapper">
            <h1>{i18n.t('faq_title')}</h1>
            <div className="subjects-wrapper">
              {faqData && faqData.length > 0 && faqData.map((faq, index) => (// CLEAN CODE use React MEMO
                <Slink to={`faq-${index}`} spy={true} smooth={true} offset={-100} duration={800}>
                  <div
                    className="faq-subject-box"
                    role="presentation"
                    onClick={() => buttonClickEvent(`faq-topic-${index}`, faq.title,
                      'webpage', 'FAQ', 'FAQ', countryMap[country])}
                  >
                    <h3 data-lokalise="" data-key={`faqs::${faq.key}::title`}>{faq.title}</h3>
                  </div>
                </Slink>
              ))}
            </div>
            <div className="faq-section-break" />
            <div className="sections-wrapper">
              {faqData && faqData.length > 0 && faqData.map((faq, index) => (// CLEAN CODE use React MEMO
                <Fragment key={faq.key}>
                  <section className="faq-section" id={`faq-${index}`}>
                    <h2 data-lokalise="" data-key={`faqs::${faq.key}::title`}>{faq.title}</h2>
                    <div className="">
                      {faq.data && faq.data.length > 0 && faq.data.map((row, iKey) => (
                        row.question && row.question !== 'nil' && (
                          <div className="faq-collapse-wrapper">
                            <Collapse
                              title={row.question}
                              Lkey={`faqs::${faq.key}::data::${iKey}`}
                              content={row.answer}
                              topic={faq.title}
                            />
                          </div>
                        )
                      ))}
                    </div>
                  </section>
                  <div className="faq-section-break" />
                </Fragment>
              ))}
            </div>
            <section className="faq-bottom-section">
              <Row>
                <Col lg="6" md="12" sm="12">
                  <div className="faq-bottom-image">
                    {(country === 'hk' || country === 'jp') && (
                    <img
                      data-src={`/img/image_FAQ_hk_${isMobile ? 'mobile' : 'desktop'}.jpg`}
                      alt="Zenyum FAQ"
                    />
                    )}
                    {country === 'tw' && (
                    <img
                      data-src={`/img/image_FAQ_tw_${isMobile ? 'mobile' : 'desktop'}.jpg`}
                      alt="Zenyum FAQ"
                    />
                    )}
                    {(country !== 'hk' && country !== 'jp' && country !== 'tw') && (
                    <img
                      src={`/img/image_FAQ_${isMobile ? 'mobile_new' : 'desktop_new'}.jpg`}
                      data-gumlet="false"
                      alt="Zenyum FAQ"
                    />
                    )}
                  </div>
                </Col>
                <Col lg="6" md="12" sm="12">
                  <div className="faq-bottom-content h-100 d-flex align-items-center">
                    <div className="content-area">
                      <h2>{i18n.t('faq_ready_to_get_started')}</h2>
                      <h5 dangerouslySetInnerHTML={{ __html: i18n.t('start_zenyum_journey') }} />
                      <div className="bottom-button">
                        <a
                          className="btn web-btn faq-web-btn web-btn--fill text-center"
                          href={`${obt3EnabledMarkets.includes(country) ? process.env.NEXT_PUBLIC_OBT3_LINK
                            : process.env.NEXT_PUBLIC_OBT_LINK}${country}-${lang}/intro/${utmParams}`}
                        >
                          {i18n.t('faq_get_your_free_assessment_btn')}
                        </a>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </section>
          </div>
        </Container>
      </section>
      <div
        onClick={() => scroll.scrollToTop()}
        className={`scrollToTop ${isSTT ? 'active' : ''}`}
        role="presentation"
      >
        <img src="/img/icon_top.svg" alt="top arrow" />
      </div>
    </Layout>
  );
};

export async function getStaticProps({ params }) {
  const lngDict = {};
  const pageId = PAGEID.FAQS;
  const keys = getTranslationKeys(pageId);
  const { default: lngDictAll = {} } = await import(
    `../../locales/${contentLanguageMap[params.lng]}.json`
  );
  keys.forEach((data) => {
    lngDict[data] = lngDictAll[data];
  });
  return {
    props: { lng: params.lng, lngDict, pageId }
  };
}

export async function getStaticPaths() {
  return {
    paths: languages.map((l) => ({ params: { lng: l } })),
    fallback: false
  };
}

export default Faqs;
